module.exports = __webpack_public_path__ + "img/tg6_title.f4f4ac9e.png";